import React from 'react';
import axios from 'axios';

import { useTimeModal } from '../Components/TimeModal/TimeModalContext';

import Loading from '../Components/Loading';

import HeaderPanel from '../Components/HeaderPanel';

const DeactivatedAccounts = () => {
    const { openTimeModal } = useTimeModal();
    const [usersWithoutAccess, setUsersWithoutAccess] = React.useState([]);
    const [warning, setWarning] = React.useState('');
    const [loading, setLoading] = React.useState(true);

    const [reload, setReload] = React.useState(true);

    React.useEffect(() => {
        const token = localStorage.getItem('token');
        axios.get('/api/users?approval=Отключен', {
            headers: {
                Authorization: `Bearer ${token}`,
            }
        })
        .then(response => {
            if (response.data.length === 0) {
                setWarning('В данный момент деактивированные учётные записи отсутствуют.');
                setUsersWithoutAccess([]);
            } else {
                setWarning('');
                setUsersWithoutAccess(response.data);
            }
        })
        .catch(error => {
            console.error('Ошибка при получении данных:', error);
            setWarning(`Не удалось загрузить таблицу деактивированных пользователей: ${error.response?.data.message || error.message}`);
        })
        .finally(() => {
            setReload(false);
            setLoading(false);
        });
    }, [reload])

    const [confirmDelete, setConfirmDelete] = React.useState(null);
    const changeApprovalUser = (userIdForDelete) => {      
        const token = localStorage.getItem('token');

        axios.put(`/api/block-unblock-acc?userId=${userIdForDelete}`, {}, {
            headers: {
                Authorization: `Bearer ${token}`,
            }
        })
        .then(() => {
            setConfirmDelete(null);
            openTimeModal('Учётная запись активирована.', 'success');
            setReload(true);
        })
        .catch(error => {
            console.error('Ошибка при активации учётной записи пользователя:', error);
            openTimeModal(`Не удалось активировать учётную запись. ${error.response?.data.message || error.message}`, 'error');
        })
    }
    const handleChangeApprovalClick = (userIdForDelete) => {
        if (confirmDelete === userIdForDelete) {
            changeApprovalUser(userIdForDelete);
        } else {
            setConfirmDelete(userIdForDelete);
        }
    }

    return (
        <div className='mainContainer'>
            <h1>Деактивированные учётные записи</h1>
            <HeaderPanel typePanel='Назад' />
            {/* <div className={headerPanel.additionalPanel}>
                <input type='text' placeholder='Поиск' />
            </div> */}
            <div className='table-container' style={{marginBottom: '20px'}}>
                <div className='tableHeader'>
                    <a className='fioUser' style={{width: '25%'}}>ФИО</a>
                    <a className='emailUser' style={{width: '25%'}}>Электронная почта</a>
                    <a className='branchUser' style={{width: '25%'}}>Основной регион деятельности</a>
                    <a className='statusUser' style={{width: '25%'}}>Действие</a>
                </div>
                {loading && <Loading />}
                {warning && <div className='case warningLine'><a>{warning}</a></div>}
                {usersWithoutAccess.map((user) => (
                    <div className='user' key={user.id}>
                        <a className='fioUser' style={{width: '25%'}}>{user.lastname} {user.firstname} {user.surname}</a>
                        <a className='emailUser' style={{width: '25%'}}>{user.email}</a>
                        <a className='branchUser' style={{width: '25%'}}>{user.branch}</a>
                        <a className='statusUser' style={{width: '25%', borderBottom: 'none', borderRight: 'none', display: 'flex', flexDirection: 'column'}}>
                            <button 
                                type='button' 
                                className='button maxWidth' 
                                onClick={() => handleChangeApprovalClick(user.id)}
                            >
                                {confirmDelete === user.id ? 'Вы уверены?' : 'Активировать учётную запись'}
                            </button>
                        </a>
                    </div>
                ))}
            </div>
        </div>
    )
}

export default DeactivatedAccounts;